import { TUpdateFearGreedDto } from "types/Clients/WhaleShark/fearGreed/updateFearGreedDto";
import { format } from "date-fns";

const updateFearGreedMapper = (formValues: any): TUpdateFearGreedDto => {
  return {
    year: Number(format(formValues.year_month, "yyyy")),
    imageUrl: formValues.imageUrl,
    month: Number(format(formValues.year_month, "MM")),
    index: Number(formValues.index),
  };
};

export default updateFearGreedMapper;
